/**
 * 广度遍历
 *
 * @param root
 * @param calllback
 */
const breadthWorker = function (root, calllback) {
    if (!root) {
        return;
    }

    let queue = [];
    let nodes = Array.isArray(root) ? root : Array.of(root);
    nodes.forEach(function (node) {
        queue.unshift(node);
    });

    let node = queue.pop();
    while (node) {
        calllback(node);
        if (Array.isArray(node.children)) {
            node.children.forEach(function (n) {
                queue.push(n);
            });
        }
        node = queue.pop();
    }
};


/**
 * 深度遍历
 *
 * @param root
 * @param calllback
 */
const depthWorker = function (root, calllback) {
    if (!root) {
        return;
    }

    if (Array.isArray(root)) {
        root.forEach(function (node) {
            depthWorker(node.children, calllback);
            calllback(node);
        });
    } else {
        depthWorker(root.children, calllback);
        calllback(root);
    }
};


/**
 * 二分查找
 *
 * @param arr
 * @param destSubtractArrayItem
 * @returns {number}
 */
const binarySearch = function (arr, destSubtractArrayItem) {
    let low = 0;
    let high = arr.length - 1;
    while (low <= high) {
        let mid = Math.floor((high + low) / 2);
        if (0 === destSubtractArrayItem(arr[mid])) {
            return mid;
        } else if (destSubtractArrayItem(arr[mid]) > 0) {
            low = mid + 1;
        } else {
            high = mid - 1;
        }
    }
    return -1;
};


/**
 * 区间是否重叠
 * @param a
 * @param b
 * @returns {boolean|boolean}
 */
const isRangeOverlap = function (a, b) {
    return (a.x >= b.x && a.x <= b.y) || (a.y >= b.x && a.y <= b.y)
        || (b.x >= a.x && b.x <= a.y) || (b.y >= a.x && b.y <= a.y);
};


export default {
    breadthWorker,
    depthWorker,
    binarySearch,
    isRangeOverlap,
};


// WEBPACK FOOTER //
// ./src/components/core/common/Algorithm.js